/**
 * founderNote.js — copy for the founder's note (spec §5.6), mirroring the in-app
 * `dialog_cross_promo.xml` strings, adapted for visitors.
 *
 * Owner decisions: the title is the in-app title verbatim ("A note from the founder"); the website-
 * blocking bullet is corrected from the in-app "right in your browser" to "filtered right on your
 * phone". Never write "our founder", "sole founder" or "CEO", never "as seen in the app", and never
 * put "since 2016" in or next to this note.
 */
export const FOUNDER_NOTE = {
  kicker: 'Keep Me Out · Bring Me Back',
  title: 'A note from the founder',
  fallbackTitle: 'A note from the Keep Me Out team',
  body: 'To everyone who uses Keep Me Out: thank you. You told us the hardest moments happen while your phone is unlocked, too — the browser you reach for, the app you open without thinking. So we built its other half, Bring Me Back:',
  bullets: [
    'Block adult content for free, and the websites that pull you in with Premium — filtered right on your phone.',
    'A gentle pause before a time-sink opens, so you get a moment to choose.',
  ],
  signature: '— Giorgi Ediberidze, founder',
  fallbackSignature: '— The Keep Me Out team',
  footnote: 'Bring Me Back is a separate companion app, free to download for iPhone and Android.',
  compactTitle: 'Why we built Bring Me Back',
  photoAlt: 'Giorgi Ediberidze, founder',
};
